/**
 * Card video modal
 * 
 * Since we can't put anchors inside anchors
 * 
 * @since 1.0.0
 * @package crunchy
 */

(function($) {
	$(document).ready(function() {

		// sanity check featherlight
		if ( ! ( 'featherlight' in $.fn ) ) {
			return;
		}

		// set cards & bind
		var cards = $( '.cards > figure > a' );
		cards.on( 'click', doTriggerCheck );


		/**
		 * Check a clicked card to see if the
		 * video button was clicked
		 */
		function doTriggerCheck( e ) {

			if ( e.target.type == 'button' ) {

				// don't go to the linked content				
				e.preventDefault();

				// get the video
				var video = $( e.target ).data( 'video' );

				// open the modal
				doVideoModal( video );
			}
		}


		/**
		 * Open a video modal with featherlight
		 * 
		 * @param string  video  href of YouTube video from oEmbed 
		 */
		function doVideoModal( video ) {
			$.featherlight( video, { type : 'iframe' });
		}
		
	}); // document.ready
})(jQuery);
